import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Login from '../views/Login.vue'
import Register from '../views/Register.vue'
import ForgotPassword from '../views/ForgotPassword.vue'
import ResetPassword from '../views/ResetPassword.vue'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home
    },
    {
        path: '/nosotros',
        name: 'About',
        component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
    },
    {
        path: '/paquetes',
        name: 'Packages',
        component: () => import(/* webpackChunkName: "packages" */ '../views/Packages.vue')
    },
    {
        path: '/paquetes/:id',
        name: 'PackageDetail',
        component: () => import(/* webpackChunkName: "package-detail" */ '../views/PackageDetail.vue')
    },
    {
        path: '/login',
        name: 'Login',
        component: Login
    },
    {
        path: '/register',
        name: 'Register',
        component: Register
    },
    {
        path: '/olvide-password',
        name: 'ForgotPassword',
        component: ForgotPassword
    },
    {
        path: '/restablecer-password',
        name: 'ResetPassword',
        component: ResetPassword
    },
    {
        path: '/mis-cotizaciones',
        name: 'MyQuotes',
        component: () => import(/* webpackChunkName: "my-quotes" */ '../views/MyQuotes.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/verificar-email',
        name: 'VerifyEmail',
        component: () => import(/* webpackChunkName: "verify-email" */ '../views/VerifyEmail.vue')
    },
    {
        path: '/perfil',
        name: 'Profile',
        component: () => import(/* webpackChunkName: "profile" */ '../views/Profile.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/promociones',
        name: 'Promotions',
        component: () => import(/* webpackChunkName: "promotions" */ '../views/Promotions.vue')
    },
    {
        path: '/newsletter/unsubscribe',
        name: 'NewsletterUnsubscribe',
        component: () => import(/* webpackChunkName: "newsletter" */ '../views/NewsletterUnsubscribe.vue')
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router
